import { TimelineLite } from 'gsap/all';
export default () => new TimelineLite({ paused: true })
    .staggerFromTo('.js-study-1 .js-animate-block', 0.5, { autoAlpha: 0, y: -20 }, { autoAlpha: 1, y: 0 }, 0.2);
